"use strict";

var _classCallCheck = require("/Users/artemivanov/Documents/intra/ih-v5-docs-frontend/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/artemivanov/Documents/intra/ih-v5-docs-frontend/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/artemivanov/Documents/intra/ih-v5-docs-frontend/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/artemivanov/Documents/intra/ih-v5-docs-frontend/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/artemivanov/Documents/intra/ih-v5-docs-frontend/node_modules/@babel/runtime/helpers/inherits");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = withRouter;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function withRouter(ComposedComponent) {
  var WithRouteWrapper =
  /*#__PURE__*/
  function (_react$default$Compon) {
    _inherits(WithRouteWrapper, _react$default$Compon);

    function WithRouteWrapper() {
      var _this;

      _classCallCheck(this, WithRouteWrapper);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(WithRouteWrapper).apply(this, arguments));
      _this.context = void 0;
      return _this;
    }

    _createClass(WithRouteWrapper, [{
      key: "render",
      value: function render() {
        return _react.default.createElement(ComposedComponent, (0, _extends2.default)({
          router: this.context.router
        }, this.props));
      }
    }]);

    return WithRouteWrapper;
  }(_react.default.Component);

  WithRouteWrapper.displayName = void 0;
  WithRouteWrapper.getInitialProps = void 0;
  WithRouteWrapper.contextTypes = {
    router: _propTypes.default.object
  };
  WithRouteWrapper.getInitialProps = ComposedComponent.getInitialProps;

  if (process.env.NODE_ENV !== 'production') {
    var name = ComposedComponent.displayName || ComposedComponent.name || 'Unknown';
    WithRouteWrapper.displayName = "withRouter(" + name + ")";
  }

  return WithRouteWrapper;
}